(function () {
    function initEnergyStorageGalleries() {
        if (typeof window.Swiper !== 'function') return;

        document.querySelectorAll('[data-energy-storage-gallery]').forEach(function (slider) {
            if (slider.swiper) return;

            var gallery = slider.closest('.energy-storage-single__gallery');

            new window.Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 12,
                speed: 550,
                watchOverflow: true,
                keyboard: {
                    enabled: true
                },
                a11y: {
                    enabled: true
                },
                pagination: {
                    el: gallery ? gallery.querySelector('.energy-storage-single__pagination') : null,
                    clickable: true
                },
                navigation: {
                    prevEl: gallery ? gallery.querySelector('.energy-storage-single__arrow--prev') : null,
                    nextEl: gallery ? gallery.querySelector('.energy-storage-single__arrow--next') : null
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEnergyStorageGalleries);
    } else {
        initEnergyStorageGalleries();
    }
}());
